import React, { useState, useEffect } from 'react';
import './PageNavigation.css';

function PageNavigation() {
  const [activeSection, setActiveSection] = useState('home');
  const [isVisible, setIsVisible] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [hideTimeout, setHideTimeout] = useState(null);

  const sections = [
    { id: 'home', name: 'الرئيسية', icon: '🏠' },
    { id: 'about', name: 'فريق الإدارة', icon: '👥' },
    { id: 'accreditations', name: 'الاعتمادات', icon: '🏅' },
    { id: 'tests', name: 'الاختبارات', icon: '📝' },
    { id: 'divisions', name: 'الأقسام', icon: '🏢' },
    { id: 'partners', name: 'شركاء النجاح', icon: '🤝' },
    { id: 'features', name: 'المميزات', icon: '⭐' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      // Show navigation after scrolling 100px
      const shouldShow = window.scrollY > 100;
      setIsVisible(shouldShow);
      
      // Auto-hide after 3 seconds when shown
      if (shouldShow) {
        setIsHidden(false);
        if (hideTimeout) clearTimeout(hideTimeout);
        const timeout = setTimeout(() => {
          setIsHidden(true);
        }, 3000);
        setHideTimeout(timeout);
      }

      // Detect active section
      const scrollPosition = window.scrollY + 200;
      
      for (const section of sections) {
        const element = document.getElementById(section.id);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section.id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (hideTimeout) clearTimeout(hideTimeout);
    };
  }, [hideTimeout]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80; // Offset for fixed header
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  const handleMouseEnter = () => {
    setIsHidden(false);
    if (hideTimeout) clearTimeout(hideTimeout);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setIsHidden(true);
    }, 3000);
    setHideTimeout(timeout);
  };

  return (
    <div 
      className={`page-navigation ${isVisible ? 'visible' : ''} ${isHidden ? 'hidden' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="nav-items">
        {sections.map((section) => (
          <div
            key={section.id}
            className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => scrollToSection(section.id)}
            title={section.name}
          >
            <span className="nav-icon">{section.icon}</span>
            <span className="nav-text">{section.name}</span>
            <div className="nav-indicator"></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PageNavigation;
